import { t as StyledSvgIcon } from "./SvgIcon.styles-A_BRPYMJ.js";
import * as React$1 from "react";
import { jsx } from "react/jsx-runtime";

//#region src/assets/icons/feather/Plus.svg?react
const SvgPlus = (props) => /* @__PURE__ */ React$1.createElement("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React$1.createElement("path", {
	d: "M12 5V19M5 12H19",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}));

//#endregion
//#region src/icons/PlusIcon.tsx
function PlusIcon(props) {
	return /* @__PURE__ */ jsx(StyledSvgIcon, {
		component: SvgPlus,
		inheritViewBox: true,
		...props
	});
}

//#endregion
export { PlusIcon as t };
//# sourceMappingURL=PlusIcon-Cv4uSoT1.js.map